module.exports = __webpack_public_path__ + "img/WormSquirm-Presentation.f0d39998.jpg";